/**
 * Robinhood Chain constants.
 *
 * Chain IDs are compile-time constants because a mismatch is a hard safety
 * failure (docs/SECURITY.md — "Chain ID equals 4663"). RPC URLs, router
 * addresses, and factory addresses are NOT hardcoded: they are supplied through
 * validated environment config so a wrong address can never ship in a build.
 */
export const RH_CHAIN_ID_MAINNET = 4663;
export const RH_CHAIN_ID_TESTNET = 46630;
/** Native gas token on Robinhood Chain. */
export const RH_NATIVE_CURRENCY = {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18,
};
export const SUPPORTED_CHAIN_IDS = [
    RH_CHAIN_ID_MAINNET,
    RH_CHAIN_ID_TESTNET,
];
export function isSupportedChainId(chainId) {
    return SUPPORTED_CHAIN_IDS.includes(chainId);
}
//# sourceMappingURL=chain.js.map